import { render, staticRenderFns } from "./StoryStatisticViewsList.vue?vue&type=template&id=18cad524&scoped=true&"
import script from "./StoryStatisticViewsList.vue?vue&type=script&lang=ts&"
export * from "./StoryStatisticViewsList.vue?vue&type=script&lang=ts&"
import style0 from "./StoryStatisticViewsList.vue?vue&type=style&index=0&id=18cad524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cad524",
  null
  
)

export default component.exports